


class LocalStorage {

    constructor() {
        if (window.localStorage) {
            this.setJwt = this.setLocalstorageJwt;
            this.getJwt = this.getLocalstorageJwt;
            this.deleteJwt = this.deleteLocalstorageJwt;
        } else {
            // cookie implementation if required            
            // this.setJwt = this.setCookieJwt;
            // this.getJwt = this.getCookieJwt;
            // this.deleteJwt = this.deleteCookieJwt;
        }
    }

    setLocalstorageJwt(token) {
        window.localStorage.setItem('jwt', `${token}`)
    }

    getLocalstorageJwt() {
        return window.localStorage.getItem('jwt');
    }

    deleteLocalstorageJwt() {
        window.localStorage.removeItem('jwt');
    }

    setUserData(userData) {
        window.localStorage.setItem('userData', JSON.stringify(userData))
    }

    getUserData() {
        const data = window.localStorage.getItem('userData');
        if (data) {
            return JSON.parse(data);
        } else {
            return null;
        }
        
    }

    deleteUserData() {
        window.localStorage.removeItem('userData');
    }

}

export default new LocalStorage();